// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2hCzk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__YQPMa","obliqueLine":"membershipbadge_obliqueLine__1YZtE"};